import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Image from 'components/AppImage';

const StaffTable = ({ 
  staffMembers, 
  onEdit, 
  onViewDetails, 
  onToggleStatus, 
  selectedStaff, 
  onSelectStaff,
  onSelectAll,
  isAllSelected 
}) => {
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [roleDescription, setRoleDescription] = useState('N/A');

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedStaff = [...staffMembers]?.sort((a, b) => {
    let aValue = a?.[sortField];
    let bValue = b?.[sortField];
    
    if (sortField === 'hireDate') {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    }
    
    if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { color: 'bg-green-500 text-success-foreground', label: 'Active' },
      inactive: { color: 'bg-muted text-muted-foreground', label: 'Inactive' },
      suspended: { color: 'bg-warning text-warning-foreground', label: 'Suspended' }
    };
    
    // const config = statusConfig?.[status] || statusConfig?.inactive;
    const config = status? statusConfig.active : statusConfig.inactive;
    
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config?.color}`}>
        <div className={`status-indicator mr-1 ${status ? 'active' : 'inactive'}`}></div>
        {config?.label}
      </span>
    );
  };

  const getRoleBadge = (role) => {
    //let roleDescription = 'N/A';
    const roleColors = {
      'Admin': 'text-accent',
      'Scanning': 'text-accent',
      'Releasing': 'text-accent',
      'Reporting': 'text-accent'
    };

    const assignedRoles = [];


    if(role.owner || role.admin ){
      // roleDescription = 'Admin';
      assignedRoles.push('Admin');
    }
    else{
      if(role.scanning){
        assignedRoles.push('Scanning'); 
      }
      if(role.releasing){
        assignedRoles.push('Releasing'); 
      }
      
      if(role.reporting){
        assignedRoles.push('Reporting'); 
      }
      
    }
    
    
    
    return (
      assignedRoles.map((r, index) => (
        <span key={index} className={`inline-flex items-center my-1x px-2 py-1 text-xs  ${roleColors[r]}`}>
          <Icon 
            name={'ShieldCheck'} 
            size={14} 
            className="ml-1"
          />
          {r}
        </span>
      ))
    );
  };

  const SortButton = ({ field, children }) => (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => handleSort(field)}
      className="h-auto p-1 font-medium text-left justify-start hover:bg-transparent"
    >
      {children}
      <Icon 
        name={sortField === field ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} 
        size={14} 
        className="ml-1"
      />
    </Button>
  );

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      {/* Desktop Table View */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="w-12 p-4">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={onSelectAll}
                  className="rounded border-border"
                />
              </th>
              <th className="text-left p-4">
                <SortButton field="name">Staff Member</SortButton>
              </th>
              <th className="text-left p-4">
                <SortButton field="role">Role</SortButton>
              </th>
              <th className="text-left p-4">
                <SortButton field="email">Contact</SortButton>
              </th>
              <th className="text-left p-4">
                <SortButton field="hireDate">Hire Date</SortButton>
              </th>
              <th className="text-left p-4">
                <SortButton field="status">Status</SortButton>
              </th>
              <th className="text-center p-4 w-32">Actions</th>
            </tr>
          </thead>
          <tbody>
            {sortedStaff?.map((staff) => (
              <tr key={staff?.businessRoleId} className="border-b border-border hover:bg-muted/30 transition-smooth">
                <td className="p-4">
                  <input
                    type="checkbox"
                    checked={selectedStaff?.includes(staff?.businessRoleId)}
                    onChange={() => onSelectStaff(staff?.businessRoleId)}
                    className="rounded border-border"
                  />
                </td>
                <td className="p-4">
                  <div className="flex items-center space-x-3">
                    {/* <div className="w-10 h-10 rounded-full overflow-hidden bg-muted flex-shrink-0">
                      <Image
                        src={'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'}
                        alt={staff?.fullname}
                        className="w-full h-full object-cover"
                      />
                    </div> */}
                    <div>
                      <div className="font-medium text-foreground">{staff?.name+" "+staff?.surname}</div>
                      {/* <div className="text-sm text-muted-foreground">ID: {staff?.employeeId}</div> */}
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  {getRoleBadge(staff)}
                </td>
                <td className="p-4">
                  <div className="space-y-1">
                    <div className="text-sm text-foreground">{staff?.email}</div>
                    <div className="text-sm text-muted-foreground">{staff?.contactNo}</div>
                  </div>
                </td>
                <td className="p-4">
                  <div className="text-sm text-foreground">
                    {new Date(staff.created)?.toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric'
                    })}
                  </div>
                </td>
                <td className="p-4">
                  {getStatusBadge(staff?.active)}
                </td>
                <td className="p-4">
                  <div className="flex items-center justify-center space-x-1">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onViewDetails(staff)}
                      className="h-8 w-8"
                    >
                      <Icon name="Eye" size={16} />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onEdit(staff)}
                      className="h-8 w-8"
                    >
                      <Icon name="Edit" size={16} />
                    </Button>
                    {/* <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onToggleStatus(staff)}
                      className={`h-8 w-8 ${staff?.active ? 'text-warning hover:text-warning' : 'text-success hover:text-success'}`}
                    >
                      <Icon name={staff?.active? 'UserX' : 'UserCheck'} size={16} />
                    </Button> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Mobile/Tablet Card View */}
      <div className="lg:hidden space-y-4 p-4">
        {sortedStaff?.map((staff) => (
          <div key={staff?.businessRoleId} className="bg-card border border-border rounded-lg p-4 space-y-3">
            <div className="flex items-start justify-between">
              <div className="flex items-center space-x-3 flex-1">
                <input
                  type="checkbox"
                  checked={selectedStaff?.includes(staff?.businessRoleId)}
                  onChange={() => onSelectStaff(staff?.businessRoleId)}
                  className="rounded border-border mt-1"
                />
                {/* <div className="w-12 h-12 rounded-full overflow-hidden bg-muted flex-shrink-0">
                  <Image
                    src={staff?.avatar}
                    alt={staff?.name}
                    className="w-full h-full object-cover"
                  />
                </div> */}
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-foreground truncate">{staff?.name} {staff?.surname}</div>
                  {/* <div className="text-sm text-muted-foreground">ID: {staff?.employeeId}</div> */}
                  <div className="mt-1">{getRoleBadge(staff)}</div>
                </div>
              </div>
              <div className="flex items-center space-x-1">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onViewDetails(staff)}
                  className="h-8 w-8"
                >
                  <Icon name="Eye" size={16} />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(staff)}
                  className="h-8 w-8"
                >
                  <Icon name="Edit" size={16} />
                </Button>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <div className="text-muted-foreground">Email</div>
                <div className="text-foreground truncate">{staff?.email}</div>
              </div>
              <div>
                <div className="text-muted-foreground">Phone</div>
                <div className="text-foreground">{staff?.contactNo}</div>
              </div>
              <div>
                <div className="text-muted-foreground">Hire Date</div>
                <div className="text-foreground">
                  {new Date(staff.created)?.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                  })}
                </div>
              </div>
              <div>
                <div className="text-muted-foreground">Status</div>
                <div className="mt-1">{getStatusBadge(staff)}</div>
              </div>
            </div>
            
            <div className="flex justify-end pt-2 border-t border-border">
              <Button
                variant={staff?.status === 'active' ? 'outline' : 'default'}
                size="sm"
                onClick={() =>  onEdit(staff)}
                iconName={staff?.status === 'active' ? 'UserX' : 'UserCheck'}
                iconPosition="left"
                iconSize={16}
              >
                Edit
              </Button>
            </div>
          </div>
        ))}
      </div>
      {/* Empty State */}
      {staffMembers?.length === 0 && (
        <div className="text-center py-12">
          <Icon name="Users" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-medium text-foreground mb-2">No Staff Members</h3>
          <p className="text-muted-foreground mb-4">Get started by adding your first staff member.</p>
        </div>
      )}
    </div>
  );
};

export default StaffTable;